import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FILTERS, BILLING_STATUSES } from '../../../../../../common/filters/constants';

import locales from '../../locales';
import { AccountTransfersReportCreateForm } from '../interfaces';

const CreateReportFilterForm = ({
  errors,
  touched,
  values,
  handleChange,
  handleBlur
}: FiltersFormValues<AccountTransfersReportCreateForm>) => (
  <Box mt={2} mb={6}>
    <DateRangePicker
      from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
      to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
      handleFromChange={value => handleChange(FILTERS.FROM, value)}
      handleToChange={value => handleChange(FILTERS.TO, value)}
      handleBlur={handleBlur}
    />
    <DropDown
      label={locales.common.filters.statuses.label}
      placeholder={locales.common.filters.statuses.placeholder}
      value={values.statuses}
      options={BILLING_STATUSES}
      name={FILTERS.STATUSES}
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
    <ChipInput
      error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
      label={locales.common.filters.operationIds.label}
      value={values.operationIds}
      name={FILTERS.OPERATION_IDS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.common.filters.operationIds.placeholder}
      tagErrors={errors.operationIds as ChipInputTagErrors}
    />
    <ChipInput
      error={errors.sendersMsisdns?.[(errors.sendersMsisdns ?? []).length - 1]}
      label={locales.common.filters.senderPhoneNumber.label}
      value={values.sendersMsisdns}
      name={FILTERS.SENDERS_MSISDNS}
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.common.filters.senderPhoneNumber.placeholder}
      tagErrors={errors.sendersMsisdns as ChipInputTagErrors}
    />
  </Box>
);

export default CreateReportFilterForm;
